import { countryToRelavanceWord } from '@application/types';
import { useRouter } from '@application/utils';
import type { AnimalOrderByWithRelationAndSearchRelevanceInput } from '@gql/graphql';
import { AnimalOrderByRelevanceFieldEnum, CountryCode, SortOrder } from '@gql/graphql';
import { useCallback } from 'react';

export const useStudOrderBuilder = () => {
  const { countryCode } = useRouter();

  const studOrderBuilder = useCallback((): AnimalOrderByWithRelationAndSearchRelevanceInput[] => {
    return [
      ...(countryCode !== CountryCode.EU
        ? [
            {
              _relevance: {
                fields: [AnimalOrderByRelevanceFieldEnum.tags],
                search: `${countryToRelavanceWord[countryCode]}`,
                sort: SortOrder.desc,
              },
            },
          ]
        : []),
      { owner: { connectedAt: SortOrder.desc } },
    ];
  }, [countryCode]);

  return { studOrderBuilder };
};
